/* 
Author:Lamiaa Moustafa
Desc: Forgot password page UI
*/

import React from "react";
import { Link } from "react-router-dom";
import { ButtonDiv, TransDiv } from "../../Styles/styledComponents/Divs";
import { Slogan } from '../../components/text/Slogan';
import { FormInput } from '../../components/inputs/FormInput';
import { Button1st2911 } from '../../components/buttons/Button1st2911';
import Text1st2911 from "../../components/text/Text1st2911";
import {ForgotText} from "../../Styles/styledComponents/Text"
import { EmailInput } from "../../Styles/styledComponents/Inputs";


const ForgotPassword = () => {
  return (
    <>
    <TransDiv>
    <Slogan data={{ label: "FORGOT YOUR" }} />
    <Slogan  data={{ label: "PASSWORD"}} />
  <Text1st2911 data={{text:"Enter your email address, and we will send you a reset", customStyle:ForgotText}}/>
    <FormInput
      data={{
        name: "email",
        type:"email",
        placeholder: "Email Address",
        customStyle: EmailInput,
        width:"50%"
      }}
    />
    <ButtonDiv>
      <Button1st2911 data={{ label: "SEND" }} />
      <Link className="linkStyle" to="/forgotpassword">Click here to send email again?</Link>
    </ButtonDiv>
  </TransDiv>
  </>
  )
}
export default ForgotPassword;

